import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

import LoggerService,{formatInfo} from './LoggerService';

// les libellés embarqués
import fr from '../i18n/fr.json';
import en from '../i18n/en.json';


/**
 * Service gérant les libellés et la langue de l'app
 * @folder Services
 * @class
 */
class I18nService {
  private static _instance: I18nService;

  logger?: any;

  /**
   * Renvoie l'instance du service
   * @returns {OsacPlanifAPIService} singleton instance
   */
  static getInstance() {
    if (!I18nService._instance) {
      I18nService._instance = new I18nService();
    }
    return I18nService._instance;
  }

  private constructor() {
    this.logger = LoggerService.getInstance();
  }

  /**
   * Initialise i18n
   * @param lng
   * @param isDebugEnabled
   */
  init(lng?: string) {

    i18n
      .use(initReactI18next) // passes i18n down to react-i18next
      .init({
        // the translations
        // (tip move them in a JSON file and import them,
        // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
        resources: {
          fr: {
            translation: fr
          },
          en: {
            translation: en
          }
        },
        lng, // if you're using a language detector, do not define the lng option
        fallbackLng: 'fr',
        interpolation: {
          escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
        }
      });
    this.logger.info(...formatInfo('I18nService initialized'));
  }

  /**
   * Renvoie la langue courante
   * @returns
   */
  getLocale():string {
    return i18n.language;
  }

  /**
   * Renvoie la traduction associée à la clé
   * @param {string} key clé
   * @returns {string}
   */
  t(key:string|string[]):string {
    return i18n.t(key);
  }

}
export default I18nService;
